import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const defaultUsersListFilter = {
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    address: "",
    isActive: false,
}

const initialState = {
    usersListFilter: defaultUsersListFilter,
    allUsers: [],
    loading: false,
    error: null,
};

const adminUserSlice = createSlice({
    name: 'adminUser',
    initialState,
    reducers: {
        setAllUsers: (state, action) => {
            state.allUsers = Array.isArray(action.payload) ? action.payload?.map((item, index) => ({ ...item })) : [];
        },
        setUsersListFilter: (state, action) => {
            state.usersListFilter = action.payload ? action.payload : defaultUsersListFilter
        },
    },
    extraReducers: (builder) => {
    },
});

export const { setAllUsers, setUsersListFilter } = adminUserSlice.actions;

export default adminUserSlice.reducer;